import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { dlStyles } from "../../../styles";
import type { Package } from "../entities";
import { when } from "lit/directives/when.js";

@customElement("umb-market-package-sidebar-links")
export class UmbMarketPackageSidebarLinks extends LitElement {
  @property({ type: Object })
  package?: Package;

  #getSupplementaryLink = (url?: string, text?: string) => {
    if (!url) return null;

    return html`<li>
      <a href=${url} target="_blank">${text}</a>
    </li>`;
  };

  render() {
    if (!this.package) return null;

    return html`<div>
      <dl>
        <div>
          <dt>Links</dt>
          <dd>
            <ul>
              ${this.#getSupplementaryLink(
                this.package.discussionForumUrl,
                "Discussion forum"
              )}
              ${this.#getSupplementaryLink(
                this.package.documentationUrl,
                "Documentation"
              )}
              ${this.#getSupplementaryLink(
                this.package.issueTrackerUrl,
                "Issue tracker"
              )}
              ${this.#getSupplementaryLink(
                this.package.licenseUrl,
                "License information"
              )}
              ${when(
                this.package.packageSource === "NPM",
                () =>
                  this.#getSupplementaryLink(
                    `https://npmjs.com/${this.package?.packageId}`,
                    "NPM source"
                  ),
                () =>
                  this.#getSupplementaryLink(
                    `https://nuget.org/packages/${this.package?.packageId}`,
                    "NuGet source"
                  )
              )}
              ${this.#getSupplementaryLink(
                this.package.projectUrl,
                "Package information"
              )}
              ${this.#getSupplementaryLink(
                this.package.sourceCodeRepositoryUrl,
                "Source repository"
              )}
            </ul>
          </dd>
        </div>
      </dl>
    </div>`;
  }

  static styles = [
    dlStyles,
    css`
      :host {
        display: block;
      }

      dd {
        container-type: inline-size;
      }

      @container (min-width:320px) {
        ul {
          columns: 2;
        }
      }
    `,
  ];
}
